import { schemes } from "@zeal/common";
import { z } from "zod";

export const submitOrderPaymentSchema = z.object({
  paymentInstrumentID: schemes.uuid(),
  orderID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  companyID: schemes.uuid(),
  sessionKey: z.string(),
});

export type TSubmitOrderPaymentRequest = z.infer<
  typeof submitOrderPaymentSchema
>;
